// extracted by mini-css-extract-plugin
module.exports = {"filterLabel":"softcontent-filters_filterLabel__wmgqg"};